
import { reactive } from 'vue'
import { Button, Dialog } from 'vant'
import SingleChoice from '@/components/choice/SingleChoice'
import InfoInput from '@/components/input/InfoInput'
import ManyInput from '@/components/input/ManyInput'
import CitySelect from '@/components/citySelect/index'
import DropDownBox from '@/components/dropDownBox/index'
import Cascader from '@/components/cascader/index'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

// 选择相关逻辑
const useChoiceEffect = (answers) => {
  // 单多选择题/输入框选择变动处理
  const handleRadioSelect = (data) => {
    // 防止输入题的值为空的时候被过滤掉
    if (!data.value && !data.type) {
      return null
    }

    // 找到更改的部分，假如是新的题目第一次选直接推进去
    const res = answers.filter(
      (item) => item.questionKey === data.questionKey
    )[0]
    if (res) {
      // 处理input内容
      if (data.type === 'input') {
        res.answers[0].answerContent = data.value
      } else {
        res.answers[0].optionKey = data.value.join(',')
      }
    } else {
      if (data.type === 'input') {
        answers.push({
          questionKey: data.questionKey,
          questionType: data.questionType,
          answers: [
            {
              questionKey: data.questionKey,
              optionKey: data.optionKey,
              answerContent: data.value,
            },
          ],
        })
      } else {
        answers.push({
          questionKey: data.questionKey,
          questionType: data.questionType,
          answers: [
            {
              questionKey: data.questionKey,
              optionKey: data.value.join(','),
              answerContent: data.answerContent,
            },
          ],
        })
      }
    }
  }

  // 多项填空题
  const hanldeManyInput = (data) => {
    const index = answers.findIndex((v, i) => {
      return v.questionKey === data.questionKey
    })
    if (index === -1) {
      answers.push(data)
    } else {
      answers[index] = data
    }
  }

  // 城市选择
  const handleSelectCity = (data) => {
    let res = answers.filter((item) => item.questionKey === data.questionKey)[0]

    if (res) {
      res = data
    } else {
      answers.push(data)
    }
  }

  return {
    answers,
    handleRadioSelect,
    hanldeManyInput,
    handleSelectCity,
  }
}

// 提交相关逻辑
const useSubmitEffect = (props, ctx) => {
  const answers = reactive([])
  const store = useStore()
  const route = useRoute()

  // 提交个人信息
  const handleSubmitPersonInfo = () => {
    if (parseInt(route.query.isPreview) === 1) {
      ctx.emit('finishedPerson')
      return
    }
    const requiredList = props.personList.filter(
      (item) => item.isRequired === 1
    )
    // if (store.getters?.getQuesInfo?.type === 1 && requiredList.length > answers.length) {
    if (requiredList.length > answers.length) {
      // 有必填没完成
      Dialog({ message: '您有必填题目未完成' })
      return
    }
    store.commit('setPersonAnswers', {
      list: answers,
    })
    ctx.emit('finishedPerson')
    ctx.emit('close')
  }

  return {
    answers,
    handleSubmitPersonInfo,
  }
}

export default {
  props: {
    personList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['finishedPerson', 'close'],
  components: {
    SingleChoice,
    InfoInput,
    CitySelect,
    ManyInput,
    DropDownBox,
    Cascader,
    Button,
  },
  setup(props, ctx) {
    const { answers, handleSubmitPersonInfo } = useSubmitEffect(props, ctx)

    // 选择
    const { handleRadioSelect, handleSelectCity, hanldeManyInput } =
      useChoiceEffect(answers)

    return {
      handleRadioSelect,
      handleSelectCity,
      hanldeManyInput,
      handleSubmitPersonInfo,
    }
  },
}
